import React, { useState, useEffect } from "react";
import ImageUploader from "./ImageUploader";
import imageCompression from 'browser-image-compression';

const maxSizeMB = 1;

const UploadImage = props => {
    const [showPreview, setShowPreview] = useState(true);

    useEffect(() => {
        if (!props.pictures || props.pictures.length === 0) {
            setShowPreview(false);
        } else {
            setShowPreview(true);
        }
    }, [props.pictures]);

    const handleImageUpload = async (imageFile) => {
        if (!imageFile || imageFile.type === 'application/pdf' || imageFile.name?.toLowerCase().endsWith('.pdf')) {
            return imageFile;
        }

        const options = {
            maxSizeMB: maxSizeMB,
            maxWidthOrHeight: props.maxWidthOrHeight ?? 1920,
            useWebWorker: true
        };

        try {
            const compressedBlob = await imageCompression(imageFile, options);
            const compressedFile = new File([compressedBlob], imageFile.name, {
                type: compressedBlob.type || imageFile.type,
                lastModified: Date.now()
            });
            return compressedFile;
        } catch (error) {
            console.log("Image compression failed, using original file:", error);
            return imageFile;
        }
    };

    const onDrop = async (files, dataURLs) => {
        if (!files || files.length === 0) {
            setShowPreview(false);
            if (props.onImagesSelected) {
                props.onImagesSelected([]);
            }
            return;
        }

        const newPictures = [];
        for (const pic of files) {
            let file = (pic.type === 'application/pdf' || pic.name?.toLowerCase().endsWith('.pdf'))
                ? pic
                : await handleImageUpload(pic);
            if (file) {
                newPictures.push(file);
            }
        }

        setShowPreview(true);

        if (props.onImagesSelected) {
            props.onImagesSelected(newPictures);
        }
    };

    return (
        <ImageUploader
            {...props}
            pictures={props.pictures}
            withIcon={props.withIcon !== undefined ? props.withIcon : true}
            withPreview={props.withPreview !== undefined ? props.withPreview : showPreview}
            withLabel={props.withLabel !== undefined ? props.withLabel : true}
            buttonText={props.buttonText || 'Choose Images / Docs'}
            accept={props.accept || "image/*,application/pdf,.pdf"}
            onChange={onDrop}
            imgExtension={props.imgExtension || ['.jpg', '.gif', '.png', '.jpeg', '.pdf']}
            maxFileSize={props.maxFileSize || 26214400} // 25mb
            label={props.label || 'Accepted: jpg, png, gif, jpeg, pdf'}
        />
    );
};

export default UploadImage;